import React, { useState, useEffect } from 'react';
import Magnifier from 'react-magnifier';
import { NavLink } from 'react-router-dom';

const NewHeaderTitle = ({ title, descList, buttonText, imgSrc, imgSrcRidimensionabile, imgSrcRidimensionabileBackground, eventualDesc, eventualHref }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
        <div id={eventualHref} className='width100 perflex bg-title'>
            <div id="new-header-div" className="new-header-div ">

                <div className="new-header-div-first">
                    <div className="new-header-title">
                        {title}
                    </div>

                    <div className="new-header-desc">
                        {descList && descList.map((desc, index) => (
                            <p>{desc}</p>
                        ))}
                    </div>

                    <NavLink to="/contact-us"><button id="button-third">{buttonText}</button></NavLink>
                </div>
                {imgSrcRidimensionabile &&
                    <div className="new-header-div-second">
                         {eventualDesc && <div className='eventualDesc'>
                            {eventualDesc}
                        </div>}
                        {windowWidth < 1200 ? (
                            <img src={imgSrc} style={{width: "100%"}} />
                        ) : (
                            <Magnifier src={imgSrcRidimensionabile}
                                width={500}
                                mgWidth={300}
                                mgHeight={300}
                                zoomFactor={0.5}
                                mgShape="circle"
                                zoomImgSrc={imgSrcRidimensionabileBackground}
                            />
                        )}
                    </div>
                }
                {!imgSrcRidimensionabile &&
                    <div className="new-header-div-second">
                        {eventualDesc && <div className='eventualDesc'>
                            {eventualDesc}
                        </div>}
                        <img src={imgSrc} width={500} />
                    </div>
                }

            </div>
            </div>
        </>
    );
};

export default NewHeaderTitle;